import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ICancellationPolicyModalResultsDisplayData } from 'model/view-models/results/product-card/price-display-data.interface';

@Component({
  selector: 'usb-cancellation-policies',
  templateUrl: './cancellation-policies.component.html',
  styleUrls: ['./cancellation-policies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancellationPoliciesComponent implements OnInit {

  @Input() cancellationPolicies!: ICancellationPolicyModalResultsDisplayData;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Input() categoryId: number = 0;

    // ✅ Cachear los valores calculados
  private cachedValues: {
    segmentWidths: number[];
    todayPosition: number;
    nextDates: Date[];
    today: Date;
  } | null = null;

  private lastInputHash: string = '';


  constructor() { }

  ngOnInit(): void {
    this.calculateValues();
  }

adjustDate(date: string | Date, days: number): string {
  if (!date) return '';

  // Convertir Date a string si es necesario
  let dateStr: string;
  if (typeof date === 'string') {
    dateStr = date;
  } else {
    // Asumiendo que es un objeto Date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    dateStr = `${year}-${month}-${day}`;
  }

  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

splitHour(hour: any): string {
  if (!hour) {
    return '';
  }
  // Separa por espacio y toma la primera parte (ej: "13:00")
  return hour.split(' ')[0];
}

splitText(hour: any): string {
  if (!hour) {
    return '';
  }
  // Separa por espacio y toma el resto (ej: "UTC-3 Hora Argentina")
  const parts = hour.split(' ');
  parts.shift(); // Elimina la primera parte (la hora)
  return parts.join(' ');
}
  // ✅ Calcular todos los valores una sola vez
  private calculateValues(): void {
    if (!this.cancellationPolicies) return;

    const total = (this.cancellationPolicies?.cancellationPolicies?.length || 0) + 2;
    const segmentWidth = 100 / total;

    const today = new Date();
    const from = new Date(this.cancellationPolicies.from);
    const arrival = new Date(this.cancellationPolicies.arrivalDate);

    // Calcular posición del HOY
    let todayPosition = segmentWidth / 2;
    if (today >= from && today < arrival) {
      const policies = this.cancellationPolicies.cancellationPolicies;
      for (let i = 0; i < policies.length; i++) {
        const policyFrom = new Date(policies[i].from);
        const nextFrom = i < policies.length - 1 ? new Date(policies[i + 1].from) : arrival;
        if (today >= policyFrom && today < nextFrom) {
          todayPosition = ((i + 1) * segmentWidth) + segmentWidth / 2;
          break;
        }
      }
    } else if (today >= arrival) {
      todayPosition = 100 - segmentWidth / 2;
    }

    // Calcular fechas siguientes
    const nextDates: Date[] = [];
    const policies = this.cancellationPolicies.cancellationPolicies;
    for (let i = 0; i < policies.length; i++) {
      if (i < policies.length - 1) {
        nextDates.push(new Date(policies[i + 1].from));
      } else {
        nextDates.push(new Date(this.cancellationPolicies.arrivalDate));
      }
    }

    this.cachedValues = {
      segmentWidths: Array.from({ length: total }, () => segmentWidth),
      todayPosition,
      nextDates,
      today
    };
  }

  // ✅ Usar los valores cacheados
  getSegmentWidth(index: number): number {
    if (!this.cachedValues) this.calculateValues();
    return this.cachedValues?.segmentWidths[index] || 0;
  }

  getTodayPosition(): number {
    if (!this.cachedValues) this.calculateValues();
    return this.cachedValues?.todayPosition || 0;
  }

  getNextDate(index: number): Date {
    if (!this.cachedValues) this.calculateValues();
    return this.cachedValues?.nextDates[index] || new Date();
  }

  get today(): Date {
    if (!this.cachedValues) this.calculateValues();
    return this.cachedValues?.today || new Date();
  }

  // ✅ Forzar recálculo cuando cambian los inputs
  ngOnChanges(): void {
    this.calculateValues();
  }

}
